export const gatsbyImagePlaceholderStyle = {transitionDelay: "0", transition: "0.5s", filter: "blur(40px)"}